var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.conRegistros
      ? _c("div", { staticStyle: { "text-align": "center" } }, [
          _vm._v(" Documento sin referencias ")
        ])
      : _vm._e(),
    _vm.conRegistros
      ? _c(
          "div",
          [
            _c("h4", [_vm._v(_vm._s(_vm.titulo))]),
            _c("h5", { staticStyle: { color: "#aaaaaa" } }, [
              _vm._v(_vm._s(_vm.subtitulo))
            ]),
            _c(
              "vs-tabs",
              { staticClass: "mt-4" },
              [
                _c(
                  "vs-tab",
                  { attrs: { label: "Referencias a este documento" } },
                  [
                    _c(
                      "vs-collapse",
                      [
                        _c("vs-collapse-item", { attrs: { open: "" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _vm._v(
                                " Documentos Tributarios Electrónicos (DTE) "
                              )
                            ]
                          ),
                          _vm.getData.referenciadosTipoDte.length == 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#dddddd"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Sin documentos que hagan referencia a este documento "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "vs-row",
                                    {
                                      staticStyle: {
                                        "border-bottom": "1px solid #555555"
                                      }
                                    },
                                    [
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "5"
                                          }
                                        },
                                        [_vm._v("Tipo documento")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "4"
                                          }
                                        },
                                        [_vm._v("Folio")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "3"
                                          }
                                        },
                                        [_vm._v("Fecha")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.getData.referenciadosTipoDte,
                                    function(col, index) {
                                      return _c(
                                        "vs-row",
                                        {
                                          key: index,
                                          staticClass: "mt-2 mb-2"
                                        },
                                        [
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "left",
                                                "vs-align": "left",
                                                "vs-w": "5"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  col.tipoDocumentoReferencia
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "4"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                { attrs: { href: "#" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(col.folioReferencia)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "3"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(col.fechaReferencia)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                        ]),
                        _c("vs-collapse-item", { attrs: { open: "" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_vm._v(" Otro tipo de documentos electrónicos ")]
                          ),
                          _vm.getData.referenciadosTipoDnt.length == 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#dddddd"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Sin documentos que hagan referencia a este documento "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "vs-row",
                                    {
                                      staticStyle: {
                                        "border-bottom": "1px solid #555555"
                                      }
                                    },
                                    [
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "5"
                                          }
                                        },
                                        [_vm._v("Tipo documento")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "4"
                                          }
                                        },
                                        [_vm._v("Folio")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "3"
                                          }
                                        },
                                        [_vm._v("Fecha")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.getData.referenciadosTipoDnt,
                                    function(col, index) {
                                      return _c(
                                        "vs-row",
                                        {
                                          key: index,
                                          staticClass: "mt-2 mb-2"
                                        },
                                        [
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "left",
                                                "vs-align": "left",
                                                "vs-w": "5"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  col.tipoDocumentoReferencia
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "4"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                { attrs: { href: "#" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(col.folioReferencia)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "3"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(col.fechaReferencia)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "vs-tab",
                  { attrs: { label: "Referencias a otros documentos" } },
                  [
                    _c(
                      "vs-collapse",
                      [
                        _c("vs-collapse-item", { attrs: { open: "" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _vm._v(
                                " Documentos Tributarios Electrónicos (DTE) "
                              )
                            ]
                          ),
                          _vm.getData.referenciasTipoDte.length == 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#dddddd"
                                  }
                                },
                                [
                                  _vm._v(
                                    " No hay referencias a otros documentos "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "vs-row",
                                    {
                                      staticStyle: {
                                        "border-bottom": "1px solid #555555"
                                      }
                                    },
                                    [
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "5"
                                          }
                                        },
                                        [_vm._v("Tipo documento")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "4"
                                          }
                                        },
                                        [_vm._v("Folio")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "3"
                                          }
                                        },
                                        [_vm._v("Fecha")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.getData.referenciasTipoDte,
                                    function(col, index) {
                                      return _c(
                                        "vs-row",
                                        {
                                          key: index,
                                          staticClass: "mt-2 mb-2"
                                        },
                                        [
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "left",
                                                "vs-align": "left",
                                                "vs-w": "5"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  col.tipoDocumentoReferencia
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "4"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                { attrs: { href: "#" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(col.folioReferencia)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "3"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(col.fechaReferencia)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                        ]),
                        _c("vs-collapse-item", { attrs: { open: "" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_vm._v(" Documentos No Tributarios (DNT) ")]
                          ),
                          _vm.getData.referenciasTipoDnt.length == 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#dddddd"
                                  }
                                },
                                [
                                  _vm._v(
                                    " No hay referencias a otros documentos "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "vs-row",
                                    {
                                      staticStyle: {
                                        "border-bottom": "1px solid #555555"
                                      }
                                    },
                                    [
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "left",
                                            "vs-align": "left",
                                            "vs-w": "5"
                                          }
                                        },
                                        [_vm._v("Tipo documento")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "4"
                                          }
                                        },
                                        [_vm._v("Folio")]
                                      ),
                                      _c(
                                        "vs-col",
                                        {
                                          attrs: {
                                            "vs-type": "flex",
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "3"
                                          }
                                        },
                                        [_vm._v("Fecha")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.getData.referenciasTipoDnt,
                                    function(col, index) {
                                      return _c(
                                        "vs-row",
                                        {
                                          key: index,
                                          staticClass: "mt-2 mb-2"
                                        },
                                        [
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "left",
                                                "vs-align": "left",
                                                "vs-w": "5"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  col.tipoDocumentoReferencia
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "4"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                { attrs: { href: "#" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(col.folioReferencia)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "vs-col",
                                            {
                                              attrs: {
                                                "vs-type": "flex",
                                                "vs-justify": "center",
                                                "vs-align": "center",
                                                "vs-w": "3"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(col.fechaReferencia)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }